import React, { useState } from "react";

import StandardButton from "../../../../../../components/Buttons/StandardButton";
import TextInputModal from "../../../../../../components/Modals/TextInputModal";
import { useRouteBuilder } from "../../context/RouteBuilderContext";
import { canApplyRouteBuilderSession } from "../../lib/routeValidation";

/** Cancel and persistence actions for the adjust modal header. */
export default function AdjustHeaderActions({
  onCancel,
}: {
  onCancel: () => void;
}) {
  const {
    session,
    activeDraftId,
    saveSessionAsDraft,
    saveActiveDraftChanges,
    createRoutesFromBuilder,
    isBusy,
  } = useRouteBuilder();

  const [draftNameOpen, setDraftNameOpen] = useState(false);

  const closeButton = (
    <button
      type="button"
      data-testid="route-builder-adjust-close"
      disabled={isBusy}
      className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-100 hover:text-slate-900"
      onClick={onCancel}
    >
      Cancel
    </button>
  );

  if (!session) {
    return (
      <div className="flex flex-wrap items-center gap-2">{closeButton}</div>
    );
  }
  const canCreateRoutes = canApplyRouteBuilderSession(session);
  return (
    <div className="flex flex-wrap items-center gap-2">
      {closeButton}
      {activeDraftId ? (
        <StandardButton
          color="green"
          label="Save changes"
          disabled={isBusy}
          onClick={() => saveActiveDraftChanges()}
          testId="save-draft-changes-button"
          className="!px-3 !py-2"
        />
      ) : (
        <StandardButton
          color="green"
          label="Save as draft"
          disabled={!session.routes.length || isBusy}
          onClick={() => setDraftNameOpen(true)}
          testId="save-as-draft-button"
          className="!px-3 !py-2"
        />
      )}
      <StandardButton
        color="blue-gradient"
        label={
          session.builderMode === "edit" ? "Update routes" : "Create routes"
        }
        disabled={!canCreateRoutes || isBusy}
        onClick={() => createRoutesFromBuilder()}
        testId="create-routes-button"
        className="!px-3 !py-2"
      />
      <TextInputModal
        open={draftNameOpen}
        title="Save as draft"
        description="You'll find it under Drafts, at the top of the Groups view on Routes."
        label="Draft name"
        defaultValue={`${session.inputs.season} draft (${session.routes.length} routes)`}
        confirmLabel="Save draft"
        testIdPrefix="draft-name"
        onCancel={() => setDraftNameOpen(false)}
        onSave={async (name) => {
          const ok = await saveSessionAsDraft(name);
          if (ok) setDraftNameOpen(false);
        }}
      />
    </div>
  );
}
